module.exports = __webpack_public_path__ + "img/ml@3x.ae557241.png";